var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningGraphics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4284 15.7962C79.7816 16.141 80.0001 16.6171 80.0001 17.1429C80.0001 17.6686 79.7816 18.1448 79.4284 18.4895C79.075 18.8343 78.5872 19.0476 78.0489 19.0476C76.9718 19.0476 76.0977 18.1943 76.0977 17.1429C76.0977 16.6171 76.3162 16.141 76.6694 15.7962C77.0227 15.4514 77.5105 15.2381 78.0489 15.2381C78.5872 15.2381 79.075 15.4514 79.4284 15.7962Z",
    fill: "#94D4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6232 72.9391C71.9764 73.2841 72.1949 73.7603 72.1949 74.2858C72.1949 74.8113 71.9764 75.2877 71.6232 75.6325C71.2698 75.9772 70.782 76.1906 70.2437 76.1906C69.1666 76.1906 68.2925 75.3372 68.2925 74.2858C68.2925 73.7601 68.511 73.2839 68.8642 72.9391C69.2176 72.5944 69.7054 72.381 70.2437 72.381C70.782 72.381 71.2698 72.5944 71.6232 72.9391Z",
    fill: "#94D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.317 0C70.0116 0 72.1951 2.13143 72.1951 4.7619C72.1951 7.39238 70.0116 9.52381 67.317 9.52381C64.6224 9.52381 62.439 7.39238 62.439 4.7619C62.439 2.13143 64.6224 0 67.317 0Z",
    fill: "#F88F19"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6099 74.2858C57.2255 74.2858 58.5368 75.5658 58.5368 77.143C58.5368 78.7201 57.2255 80.0001 55.6099 80.0001C53.9943 80.0001 52.6831 78.7201 52.6831 77.143C52.6831 75.5658 53.9941 74.2858 55.6099 74.2858Z",
    fill: "#F88F19"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1115 4.54101C52.4647 4.88577 52.6832 5.36196 52.6832 5.88767C52.6832 6.41339 52.4647 6.88958 52.1115 7.23434C51.7581 7.5791 51.2703 7.79243 50.732 7.79243C49.6549 7.79243 48.7808 6.9391 48.7808 5.88767C48.7808 5.36196 48.9993 4.88577 49.3525 4.54101C49.7058 4.19624 50.1936 3.98291 50.732 3.98291C51.2703 3.98291 51.7581 4.19624 52.1115 4.54101Z",
    fill: "#94D4FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3551 76.7483C42.7083 77.0933 42.9269 77.5695 42.9269 78.095C42.9269 78.6205 42.7083 79.0969 42.3551 79.4417C42.0018 79.7864 41.514 79.9998 40.9756 79.9998C39.8986 79.9998 39.0244 79.1464 39.0244 78.095C39.0244 77.5693 39.2429 77.0931 39.5961 76.7483C39.9495 76.4036 40.4373 76.1902 40.9756 76.1902C41.514 76.1902 42.0018 76.4036 42.3551 76.7483Z",
    fill: "#94D4FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6963 2.46288C29.0496 2.80764 29.2682 3.28383 29.2682 3.80955C29.2682 4.33526 29.0496 4.81145 28.6963 5.15621C28.3431 5.50098 27.8553 5.71431 27.3169 5.71431C26.2397 5.71431 25.3657 4.86098 25.3657 3.80955C25.3657 3.28383 25.5843 2.80764 25.9374 2.46288C26.2908 2.11812 26.7786 1.90479 27.3169 1.90479C27.8553 1.90479 28.3431 2.11812 28.6963 2.46288Z",
    fill: "#94D4FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75595 3.80975C11.9121 3.80975 13.6584 5.51452 13.6584 7.61928C13.6584 9.72404 11.9121 11.4288 9.75595 11.4288C7.59986 11.4288 5.85352 9.72404 5.85352 7.61928C5.85352 5.51452 7.59986 3.80975 9.75595 3.80975Z",
    fill: "#F88F19"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33054 71.0342C3.6839 71.3791 3.90244 71.8553 3.90244 72.3808C3.90244 72.9064 3.6839 73.3827 3.33054 73.7275C2.97737 74.0723 2.48956 74.2856 1.95122 74.2856C0.873951 74.2856 0 73.4323 0 72.3808C0 71.8551 0.218537 71.3789 0.571707 71.0342C0.925073 70.6894 1.41288 70.4761 1.95122 70.4761C2.48956 70.4761 2.97737 70.6894 3.33054 71.0342Z",
    fill: "#94D4FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7925 57.6408L42.2 20.0671C42.2 20.0671 41.565 18.7546 40 18.7546C38.435 18.7546 37.8 20.0671 37.8 20.0671L14.2075 57.6408C14.2075 57.6408 13.75 58.2546 13.75 59.0833C13.75 60.4646 14.8687 61.5833 16.25 61.5833H63.75C65.1312 61.5833 66.25 60.4646 66.25 59.0833C66.25 58.2546 65.7925 57.6408 65.7925 57.6408Z",
    fill: "url(#paint0_linear_2166_10142)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0174 56.5833C39.1024 56.5833 38.3474 56.3058 37.7524 55.7508C37.1574 55.1958 36.8599 54.5246 36.8599 53.7346C36.8599 52.9108 37.1599 52.2358 37.7611 51.7096C38.3611 51.1833 39.1136 50.9208 40.0174 50.9208C40.9324 50.9208 41.6824 51.1871 42.2649 51.7183C42.8486 52.2508 43.1399 52.9221 43.1399 53.7346C43.1399 54.5583 42.8511 55.2383 42.2736 55.7758C41.6961 56.3133 40.9436 56.5833 40.0174 56.5833ZM42.7949 32.4846L42.1936 47.7033C42.1749 48.1683 41.7924 48.5358 41.3274 48.5358H38.6036C38.1374 48.5358 37.7549 48.1671 37.7374 47.7008L37.1686 32.4833C37.1499 31.9921 37.5436 31.5833 38.0349 31.5833H41.9299C42.4211 31.5833 42.8149 31.9921 42.7949 32.4846Z",
    fill: "url(#paint1_radial_2166_10142)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2166_10142",
    x1: -375.939,
    y1: -423.259,
    x2: 56.1325,
    y2: 72.2921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB705"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2166_10142",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.7361 31.3096) scale(27.9537 27.9538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningGraphics);
export default __webpack_public_path__ + "static/media/warning-graphics.3146e9ea0d6a03a6b657c957f5a7cc07.svg";
export { ForwardRef as ReactComponent };